export enum I18N {
  ADVERTISER = 'i18n.advertiser',
  AIR_QUALITY = 'i18n.air-quality',
  CTA_TEXT = 'i18n.ctaText',
  DAYS = 'i18n.days',
  DESCRIPTION = 'i18n.description',
  FAIR = 'i18n.fair',
  GOOD = 'i18n.good',
  HOURS = 'i18n.hours',
  HUMIDITY = 'i18n.humidity',
  ISI = 'i18n.isi',
  MINUTES_ABBREVIATION = 'i18n.minutes-abbreviation',
  MODERATE = 'i18n.moderate',
  POOR = 'i18n.poor',
  PROMOTED_BY_TEXT = 'i18n.promoted-by-text',
  SECONDS_ABBREVIATION = 'i18n.seconds-abbreviation',
  TITLE = 'i18n.title',
  UNKNOWN = 'i18n.unknown',
  UV_INDEX = 'i18n.uv-index',
  VERY_POOR = 'i18n.very-poor',
  WIND = 'i18n.wind'
}

export enum SupportedLanguage {
  ARABIC = 'ar',
  BENGALI = 'bn',
  BULGARIAN = 'bg',
  CHINESE = 'zh-cn',
  CHINESE_HONG_KONG = 'zh-hk',
  CROATIAN = 'hr',
  CZECH = 'cs',
  ENGLISH = 'en',
  FRENCH = 'fr',
  GERMAN = 'de',
  HINDI = 'hi',
  HUNGARIAN = 'hu',
  INDONESIAN = 'id',
  ITALIAN = 'it',
  JAPANESE = 'ja',
  KOREAN = 'ko',
  POLISH = 'pl',
  PORTUGUESE_BRAZIL = 'pt-br',
  ROMANIAN = 'ro',
  SERBIAN = 'sr',
  SLOVAK = 'sk',
  SPANISH = 'es',
  SPANISH_MX = 'es-mx',
  TAGALOG = 'tl',
  TAGALOG_EN = 'tl-en',
  TAMIL = 'ta',
  THAI = 'th',
  VIETNAMESE = 'vi'
}
